import { HardHat, FileText, Calculator, Building2, Truck, ClipboardList, Palette, DollarSign } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const ConstructionServicesIndustry = () => (
  <IndustryPlaceholderPage
    name="Construction Services"
    fullySupported={false}
    icon={HardHat}
    iconColor="text-warning"
    iconBg="bg-[hsl(var(--warning)/0.1)]"
    headline="Construction Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps construction companies create professional project proposals, bid packages, and subcontractor agreements — all from one platform."
    valueProps={[
      { title: "Win More Bids", description: "Build comprehensive construction proposals with detailed scopes, cost breakdowns, and project timelines that general contractors and owners trust." },
      { title: "Streamline Bidding", description: "Generate standardized bid packages with material takeoffs, labor estimates, and phased schedules in minutes instead of days." },
      { title: "Built for Construction", description: "Templates for general contracting, specialty trades, commercial build-outs, residential construction, and renovation projects." },
    ]}
    features={[
      { icon: Calculator, label: "Cost Estimation Tools" },
      { icon: ClipboardList, label: "Scope of Work Builder" },
      { icon: FileText, label: "PDF Bid Packages" },
      { icon: Building2, label: "Project Phasing" },
      { icon: Truck, label: "Material Takeoffs" },
      { icon: HardHat, label: "Safety Documentation" },
      { icon: Palette, label: "Custom Branding" },
      { icon: DollarSign, label: "Change Order Management" },
    ]}
    benefits={[
      "Create project-specific proposals with phased scopes, material lists, and crew allocation",
      "Auto-calculate costs based on project scope, materials, labor rates, and equipment",
      "Generate branded bid packages with site plans and project timelines",
      "Send contracts and change orders with digital signatures for fast approval",
      "Track active bids, awarded projects, and subcontractor agreements",
      "Support GC proposals, subcontractor bids, and design-build contracts",
    ]}
    proposalTemplates={[
      "General Contracting Bid",
      "Commercial Build-Out Proposal",
      "Residential New Construction",
      "Renovation & Remodel Proposal",
      "Specialty Trade Bid Package",
    ]}
    contractTemplates={[
      "Construction Services Agreement",
      "Subcontractor Agreement",
      "Design-Build Contract",
      "Change Order Agreement",
    ]}
    faq={[
      { q: "What is Sentinel Forge for construction?", a: "Sentinel Forge is a proposal and contract platform for construction companies. It helps you build project bids, define scopes of work, and send digital contracts to owners and general contractors." },
      { q: "Can I create proposals for different project types?", a: "Yes. Templates cover general contracting, commercial build-outs, residential construction, renovations, and specialty trade bids." },
      { q: "How does cost estimation work?", a: "You define project scope, materials, labor, equipment, and overhead. The system calculates total project cost with detailed line-item breakdowns." },
      { q: "Can I manage subcontractor agreements?", a: "Yes. You can generate and send subcontractor agreements with scopes, payment terms, and insurance requirements." },
      { q: "Do clients need an account to sign contracts?", a: "No. Clients receive a secure link to review and digitally sign contracts without creating an account." },
      { q: "Can I add my company's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal, bid, and contract you generate." },
      { q: "When will construction services be available?", a: "We're building it now. Join the waitlist to get notified when the construction module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to modernize your construction bidding?"
    ctaDescription="Join construction companies preparing to automate proposals and project contracts with Sentinel Forge."
  />
);

export default ConstructionServicesIndustry;
